/* src/app/private/components/admission/admission-profile-middle-screen/admission-profile-middle-screen.component.scss */
.profile-input {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
.profile-select {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
.p-datepicker-inpu {
  background-color: var(--secondry-light-gray) !important;
  border: none !important;
}
/*# sourceMappingURL=admission-profile-middle-screen.component.css.map */
